import React from "react";
import PropTypes from "prop-types";
import LazyImage from "~hooks/lazy-image";
import keygen from "~helpers/keygen";
import { imagePrettyUrl, getAltText } from "~helpers/getters";
import OperatorCta from "~atoms/button/operator-cta";
import StarRating from "~molecules/star-rating";
import { TrackingKeys } from '~constants/tracking-api'
import styles from "./header-toplist.module.scss";

const HeaderToplist = ({ module, limit = null, moduleName = TrackingKeys?.HEADER?.TOPLIST }) => {
  const items = module?.items.length > 0 && module.items[0];
  const title = module?.module_title;
  items.items = limit ? items.items.slice(0, limit) : items.items;

  return (
    <div className={styles.toplistContainer}>
      <span className={styles.title}>{title}</span>
      {items && (
        <ul className={styles.listContainer}>
          {items.items.map((item) => (
            <li key={keygen()}>
              <LazyImage
                alt={getAltText(item?.logo, item.name)}
                src={imagePrettyUrl(item?.logo?.filename, 44, 44)}
                width={44}
                height={44}
              />
              <div className={styles.info}>
                {item.name}
                <StarRating numOfStars={5} rating={item.rating} />
              </div>
              <OperatorCta
                operator={item}
                buttonSize="s"
                tracker={items.tracker}
                gtmClass="toplist-header-cta-gtm"
                moduleName={moduleName}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

HeaderToplist.propTypes = {
  module: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({})),
    module_title: PropTypes.string,
  }),
  limit: PropTypes.number,
  moduleName: PropTypes.string,
};

export default HeaderToplist;
